import React from "react";

function CryptoBankingHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
        style={{
          backgroundImage: "url(assets/img/bg/launch_your_own_crypto_img.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <div className="container mx-auto px-4 pt-[270px] pb-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              Crypto Banking Platform Development
            </h2>

            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Our crypto banking solutions are designed to empower users with a
              seamless digital banking experience, fully tailored to the unique
              demands of the cryptocurrency market.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CryptoBankingHero;
